// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { format } from 'date-fns';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
import MansionRenovationHistoriesPropsData from '@/types/components/MansionDetail/MansionRenovationHistoriesPropsData';

type MansionRenovationHistoriesProps = {
  mansionName: string;
  mansionRenovationHistories: MansionRenovationHistoriesPropsData[];
};

// QuillエディタのLinkフォーマットを拡張
const Link = Quill.import('formats/link');

class CustomLink extends (Link as any) {
  static create(value: string) {
    const node = super.create(value);
    node.setAttribute('rel', 'noopener noreferrer nofollow');
    node.setAttribute('target', '_blank');
    return node;
  }
}

// カスタムリンクフォーマットをQuillに登録
Quill.register(CustomLink, true);

const renderQuillContent = (content: string) => {
  if (!content) {
    return <Box>コンテンツがありません</Box>;
  }

  const quillContainer = document.createElement('div');
  const quill = new Quill(quillContainer, {
    theme: 'snow',
    readOnly: true,
    modules: {
      toolbar: false,
    },
  });

  // Delta形式のコンテンツを設定
  const parsedContent = JSON.parse(content);
  quill.setContents(parsedContent);

  // getSemanticHTMLメソッドを使用してHTMLを取得
  const semanticHTML = quill.root.innerHTML;

  return <div dangerouslySetInnerHTML={{ __html: semanticHTML }} />;
};

export default function MansionRenovationHistories(props: MansionRenovationHistoriesProps) {
  const { mansionName, mansionRenovationHistories } = props;
  return (
    <Box className="bg-gray-01">
      <Box className="md:max-w-7xl md:w-full mx-auto max-md:mx-0 mt-16 max-md:mt-12 px-24 max-md:px-5 pt-16 max-md:pt-8">
        <Typography
          variant="h2"
          className="border-solid border-l-2 border-rf-black relative mb-8 pl-4 text-lg font-bold before:absolute before:top-1 before:left-[-16px] max-md:before:left-0"
        >
          {mansionName}のリノベーション事例
        </Typography>
        {mansionRenovationHistories.map((renovationHistory: MansionRenovationHistoriesPropsData) => {
          const date = format(new Date(renovationHistory.date), 'yyyy/MM/dd');

          return (
            <Box key={renovationHistory.id} id={`rf-${renovationHistory.id}`} className="max-md:pb-4 last:max-md:pb-0">
              <Container className="md:max-w-7xl md:w-full mx-auto max-md:mx-0 px-24 max-md:px-3 md:pb-16 max-md:py-5 max-md:rounded max-md:border max-md:border-gray-02 max-md:border-solid max-md:border-[1px]">
                <Box className="md:max-w-[780px] max-md:w-full md:mx-auto max-md:mx-0 md:px-6">
                  <Typography
                    component="h3"
                    variant="h3"
                    className="font-bold relative mb-8 max-md:mb-5 pb-2 text-left text-base text-rf-black border-b border-solid border-rf-black max-md:border-gray-02"
                  >
                    {renovationHistory.title}
                  </Typography>
                </Box>
                <Box className="md:max-w-[780px] max-md:w-full md:mx-auto max-md:mx-0 ql-snow">
                  <Box
                    id="wysiwyg-content-rh"
                    className="mb-7 max-md:mb-5 md:px-6 max-md:px-0 py-0 ql-editor wysiwyg-content"
                  >
                    {renderQuillContent(renovationHistory.description)}
                  </Box>
                  <Box className="mt-4 md:pr-6 text-right">
                    <Typography className="text-xs font-bold">{renovationHistory.fcShopName}</Typography>
                    <Typography className="text-xs">{date}</Typography>
                  </Box>
                </Box>
              </Container>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
